const SHARE_TITLE = "Cold Case Solvers";
const SHARE_LINE = "Join me on Cold Case Solvers!";

export function buildLobbyJoinUrl(code: string): string {
  const base = `${window.location.origin}${window.location.pathname}`;
  return `${base}?join=${encodeURIComponent(code)}`;
}

export function buildLobbyShareText(code: string): string {
  return `${SHARE_LINE}\n${buildLobbyJoinUrl(code)}`;
}

export type ShareLobbyInviteResult = "shared" | "copied";

/** Copy invite text, then open native share sheet when available. */
export async function shareLobbyInvite(code: string): Promise<ShareLobbyInviteResult> {
  const url = buildLobbyJoinUrl(code);
  const shareText = buildLobbyShareText(code);
  await navigator.clipboard.writeText(shareText);
  if (typeof navigator.share === "function") {
    try {
      await navigator.share({
        title: SHARE_TITLE,
        text: SHARE_LINE,
        url,
      });
      return "shared";
    } catch (err) {
      if (err instanceof DOMException && err.name === "AbortError") {
        return "copied";
      }
      throw err;
    }
  }
  return "copied";
}

export function readJoinCodeFromLocation(): string | null {
  const fromQuery = new URLSearchParams(window.location.search).get("join");
  if (fromQuery?.trim()) return fromQuery.trim();
  const hash = window.location.hash.replace(/^#\/?/, "");
  const joinMatch = /^join\/(.+)$/i.exec(hash);
  if (joinMatch?.[1]) {
    try {
      return decodeURIComponent(joinMatch[1]).trim();
    } catch {
      return joinMatch[1].trim();
    }
  }
  return null;
}

export function clearJoinCodeFromLocation(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("join") && !/^#\/?join\//i.test(url.hash)) return;
  url.searchParams.delete("join");
  if (/^#\/?join\//i.test(url.hash)) url.hash = "";
  window.history.replaceState({}, "", url.pathname + url.search + url.hash);
}
